<!-----------------------------------------------------------------------------------------------------------------------------------

          sharedAsset

----------------------------------------------------------------------------------------------------------------------------------->

<div class="d-flex justify-content-end" *ngIf="sharedAsset">
  <div class="d-block w-50 mr-3">
    <h4>{{'lang.globals.files'|translate}}</h4>
    <div class="position-relative w-100">

      <div style="background-size: cover; display: flex; height: 200px; width: 100%; align-items: center;
  justify-content: center; background-repeat: no-repeat;background-position: center center"
           [style.backgroundImage]=" sharedAsset?.preview?.thumbnailLink ? 'url(' + sharedAsset?.preview?.thumbnailLink + ')'
                  : sharedAsset?.preview?.link ? 'url('+sharedAsset?.preview?.link+')' :'url(./../assets/img/no-image.png)' ">
      </div>
    </div>
    <ng-scrollbar style="width: 100%; height: 280px;">
      <div class="mt-2 d-flex justify-content-between" *ngFor="let assetFile of sharedAsset?.assetFiles">
        <div class="d-flex justify-content-center">
          <div class="symbol-label" style="width: 80px; height: 80px"
               [style.backgroundImage]=" assetFile.thumbnailLink ? 'url(' + assetFile.thumbnailLink + ')'
                  : assetFile.link ? 'url('+assetFile.link+')' :'url(./../assets/img/no-image.png)' ">
          </div>
          <div class="d-flex align-items-center ml-2">
            <div class="d-block">
              <div class="d-flex font-weight-bold">
                <sb-icon icon="resolution" class="mr-1"></sb-icon>
                {{assetFile?.resolution?.id}}
              </div>
              <div class="d-flex">
                <sb-icon icon="file" class="mr-1"></sb-icon>
                {{util.formatBytes(assetFile?.size)}}
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center mr-2">
          <button (click)="convertToMediumClick.emit(assetFile)"
                  class="btn btn-primary mr-1 d-flex align-items-center">
            <sb-icon class="mr-1" icon="motive"></sb-icon>
            {{'lang.globals.toMotive' | translate}}
          </button>
        </div>
      </div>
    </ng-scrollbar>
    <div class="d-flex justify-content-end">
      <button ngbTooltip="{{'lang.globals.allToMotive' | translate}}" placement="left"
              (click)="convertAllToMediaClick.emit(sharedAsset)"
              class="btn btn-primary mr-1 d-flex align-items-center">
        <sb-icon class="mr-1" icon="motives"></sb-icon>
        {{'lang.globals.allToMotive' |translate}}
      </button>
    </div>
  </div>
  <div class="d-block w-50">

    <div class="text-muted">{{'lang.globals.name' |translate}}</div>
    <h5>{{sharedAsset.name}}</h5>
    <div class="mt-3 mb-1 text-muted">{{'lang.globals.description' |translate}}</div>
    <h5>{{sharedAsset.description}}</h5>
    <div class="mt-3 mb-1 text-muted">{{'lang.globals.repository' |translate}}</div>
    <h5>{{sharedAsset.repository?.name}}</h5>
    <div class="mt-3 mb-1 text-muted">{{'lang.globals.sharedTill' |translate}}</div>
    <h5> {{util.earlierDate(sharedAsset?.shareEnd, sharedAsset?.repository?.shareEnd)?.toString() |date: 'dd.MM.yyyy HH:mm'}}</h5>
    <div class="mt-3 mb-1 text-muted">{{'lang.globals.assetCategory'|translate}}</div>
    <h5>{{sharedAsset.category?.name}}</h5>
    <div class="mt-3 mb-1 text-muted">Tags</div>
    <div class="mt-2 mb-1 d-flex">
      <ng-container *ngIf="sharedAsset.tags && sharedAsset.tags.length <= 3">

    <span *ngFor="let tag of sharedAsset.tags; let first = first"
          class="tag tag-input mr-1">
      <span [innerHTML]="tag | truncate: 15"></span>
    </span>

      </ng-container>
      <ng-container *ngIf="sharedAsset.tags && sharedAsset.tags.length > 3">
        <div class="d-flex">
      <span [ngbPopover]="popContent" autoClose="outside"
            class="tag grey-bg white cursor-pointer" container="body" popoverClass="tag-container">
    <sb-icon class="mr-1" icon="tags"></sb-icon>
        {{sharedAsset.tags ? sharedAsset.tags.length : null}}
  </span>
        </div>
        <ng-template #popContent>
          <div class="d-flex">
      <span *ngFor="let tag of sharedAsset.tags"
            class="tag mr-1 tag-input">
        <span [innerHTML]="tag | truncate: 5"></span>
    </span>
          </div>
        </ng-template>

      </ng-container>
    </div>
    <div class="text-muted mt-3 mb-1">{{'lang.globals.modifiedAt' | translate}}</div>
    <a>
      {{sharedAsset.modifiedAt?.toString() | date: 'dd.MM.yy HH:mm:ss' }}
    </a>
  </div>
</div>
